// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'beta',
  siteUrl: 'https://beta.reports.apac.gcds.coke.com',
  internalHost: 'api.reports.beta.apac.gcds.coke.com',
  tenantId: '548d26ab-8caa-49e1-97c2-a1b1a06cc39c',
  cognito: {
    userPoolId: 'ap-southeast-1_JP4VF9yUN',
    clientId: '5adncmtecli6a5a74del76v4me',
    identityPoolId: 'ap-southeast-1:067518f5-8937-42e2-8193-cb3cde9a5279',
    region: 'ap-southeast-1',
    idpUrl: 'login.microsoftonline.com/548d26ab-8caa-49e1-97c2-a1b1a06cc39c',
    // azureAppId: '55912b2a-d3a0-4ab1-bfbc-9efbdad04d17',
    azureAppId: '41a649d6-62b4-4a22-b6c2-710c187e6fd4',
  },
  cesAPI: {
    apiKey: 'cVNDoIglJa1Qx6n03BqqF8q7TRnTJGP2jrjGgLLe'
  },
};